import { useCallback } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';

import fetch from './fetch';

function useList() {
  const { cb, key } = fetch();

  const {
    data,
    isInitialLoading,
    refetch,
    isRefetching,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(key, cb, {
    getNextPageParam: (lastPage, allPages) => lastPage?.result?.next && allPages.length + 1,
    select: (_data) => _data.pages?.flatMap((page) => page?.result?.results || []),
    refetchInterval: 10_000,
  });

  const fetchNext = useCallback(() => {
    if (!isFetchingNextPage && hasNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, isFetchingNextPage, hasNextPage]);

  return {
    data: data || [],
    isInitialLoading,
    refetch,
    isRefetching,
    fetchNextPage: fetchNext,
    isFetchingNextPage,
  };
}

export default {
  useList,
};
